if (!customElements.get('brands-filter')) {
  customElements.define(
    'brands-filter',
    class extends HTMLElement {
      constructor() {
        super();
        this._init = false;
      }

      connectedCallback() {
        if (this._init) return;
        this._init = true;

        const showTabs = this.dataset.showTabs === 'true';
        const tabs = this.querySelectorAll('[role="tab"]');
        const container = this.querySelector('[data-brands-container]');
        const tablist = this.querySelector('[role="tablist"]');

        if (!showTabs || !tabs.length) return;

        this._allCategory = tabs[0].dataset.category;
        const normalize = (s) => (s || '').toLowerCase().replace(/\s+/g, '-').trim();
        const parseCategories = (card) => {
          const raw = card?.dataset?.categories || card?.dataset?.category || '';
          return raw
            .split(/[,\s]+/)
            .map(normalize)
            .filter(Boolean);
        };

        document.querySelectorAll('brands-filter[data-show-tabs="false"]').forEach((el) => {
          const c = el.querySelector('[data-brands-container]');
          if (c && container) while (c.firstChild) container.appendChild(c.firstChild);
          const s = el.closest('.brands');
          if (s) s.style.display = 'none';
        });

        this._cards = container ? [...container.querySelectorAll('.brands__card')] : [];
        this._cardCategories = new Map(this._cards.map((card) => [card, parseCategories(card)]));
        this._tabsByCategory = new Map();
        tabs.forEach((t) => {
          const key = normalize(t.dataset.category);
          if (key && key !== normalize(this._allCategory)) this._tabsByCategory.set(key, t);
        });
        this._activeTab = tabs[0];
        this._onTab = (e) => {
          const tab = e.target?.closest?.('[role="tab"]') ?? e.target;
          if (!tab?.dataset?.category) return;
          e.preventDefault?.();
          tabs.forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab);
          });
          this._activeTab = tab;
          this._filter(tab.dataset.category);
          this._updateHrefs();
        };

        tablist?.addEventListener('click', this._onTab);
        tablist?.addEventListener('keydown', (e) => {
          const tab = e.target?.closest?.('[role="tab"]');
          if (tab && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            this._onTab({ target: tab, preventDefault: () => { } });
          }
        });

        this._filter = (cat) => {
          const catKey = normalize(cat);
          const showAll = cat === this._allCategory || !catKey;
          this._cards.forEach((card) => {
            if (showAll) {
              card.hidden = false;
              return;
            }
            const tokens = this._cardCategories.get(card) || [];
            card.hidden = !tokens.includes(catKey);
          });
        };

        this._buildHrefForTab = (card, tab) => {
          const fallback = card.dataset.fallbackHref || '';
          if (!tab) return fallback;
          const collectionUrl = tab.dataset.collectionUrl || '';
          const filterParam = tab.dataset.filterParam || '';
          const brandName = card.dataset.brandName || '';
          if (!collectionUrl || !filterParam || !brandName) return fallback;

          const separator = collectionUrl.includes('?') ? '&' : '?';
          return `${collectionUrl}${separator}${encodeURIComponent(filterParam)}=${encodeURIComponent(brandName)}`;
        };

        this._buildHref = (card) => {
          const tab = this._activeTab;
          const isAll = !tab || tab.dataset.category === this._allCategory;
          if (isAll) return card.dataset.fallbackHref || '';
          return this._buildHrefForTab(card, tab);
        };

        this._updateHrefs = () => {
          this._cards.forEach((card) => {
            const href = this._buildHref(card);
            if (href) card.setAttribute('href', href);
            else card.removeAttribute('href');
          });
        };

        this._filter(this._allCategory);
        this._updateHrefs();
      }

      disconnectedCallback() {
        const tablist = this.querySelector('[role="tablist"]');
        if (tablist && this._onTab) tablist.removeEventListener('click', this._onTab);
      }
    }
  );
}
